import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import {  useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader'; 
import logo from '../assets/images/logo.png'; 
import Image from '../components/Image';


const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoader, setIsLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isCustomer, setIsCustomer] = useState(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('role') === 'customer') {
        setIsCustomer(true);
    }
  }, []);

useEffect(() => {
    const isAuthenticated = AuthService.getCurrentUser(); // Check if the user is authenticated
    if (isAuthenticated) {
        if (isAuthenticated.role === 'customer') {
            //  navigate('/appointments');
        } else {
             navigate('/admin/dashboard'); // Redirect to dashboard if authenticated
        }
    }
}, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    
    try {
      const data = await AuthService.login(email, password, isCustomer);
      if (data && (data.status || data.authorization)) { // Handle different response structures if needed
        // Backend returns: { user/customer: {...}, authorization: { token: ... } } for success
        // Or { status: true, data: { user: ..., auth_token: ... } } if wrapper used
        
        // Adjust based on actual backend response from AuthController
        // My backend AuthController returns:
        // { user: {...}, authorization: { token: ... } }
        
        const userData = data.data?.user || data.data?.customer;
        const token = data.data?.auth_token;
        console.log(userData, token);
        if (userData && token) {
            toast.success('Login successful');
            userData.auth_token = token;
            userData.role = isCustomer ? 'customer' : userData.role; // Ensure role is set
            localStorage.setItem('user', JSON.stringify(userData));
            
            if (userData.role === 'customer') {
                window.location.href = process.env.REACT_APP_BASE_PATH + '/appointments';
            } else {
                window.location.href = process.env.REACT_APP_BASE_PATH + '/admin/dashboard';
            }
        } else if (data.status && data.data) {
            // Fallback for existing structure if any
            toast.success(data.message);
            let user = data.data.user;
            user.auth_token = data.data.auth_token;
            localStorage.setItem('user', JSON.stringify(user));

             if (user.role === 'customer') {
                window.location.href = process.env.REACT_APP_BASE_PATH + '/appointments';
            } else {
                window.location.href = process.env.REACT_APP_BASE_PATH + '/admin/dashboard';
            }
        } else {
             toast.error(data?.message || 'Login failed. Please try again.');
        }

      } else {
        toast.error(data?.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Login failed:', error);
      toast.error('Login failed. Please check your credentials.');
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="page-body-wrapper full-page-wrapper bg-light">
      <div className="row w-100 m-0 full-page-wrapper">
        <div className="content-wrapper full-page-wrapper d-flex align-items-center auth">
          <div className="col-lg-4 mx-auto">
            <div className="text-center bg-base">
              <Image alt="Logo" src={logo} className="w-100px  my-2" />
            </div>
            <div className="card">
              <div className="card-body px-5 py-5">
                <div className="text-center my-3">
                  <h3 className="card-title mb-0 fs-2"> {isCustomer ? 'Customer Login' : 'Staff Login'}</h3>
                  <p>Welcome back! login to your account</p>
                </div>
                <br />

                <form onSubmit={handleLogin}>
                  <div className="form-group my-5">
                    <label>Email *</label>
                    <input
                      type="email"
                      required
                      autoComplete="off"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control p_input"
                      placeholder="Email"
                    />
                  </div>

                  <div className="form-group my-5">
                    <label>Password *</label>
                    <div className="input-group" id="show_hide_password">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-control p_input"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        autoComplete="off"
                      />
                      <div className="input-group-addon bg-light border px-3 py-3">
                        <button type="button" className='btn btn-transparent p-0' onClick={() => setShowPassword(!showPassword)}>
                          <i
                            className={`text-dark fs-5  ${showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}`}
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="form-group d-flex align-items-center justify-content-between">
                    <div className="form-check">
                      <label className="form-check-label text-muted">
                        <input type="checkbox" className="form-check-input" /> Remember me
                      </label>
                    </div>
                    <Link to={`/forgot-password?role=${isCustomer ? 'customer' : 'staff'}`} className="forgot-pass">Forgot password</Link>
                  </div>
                  
                  <div className="text-center">
                    <button type="submit" className="btn btn-base w-100 mt-4" disabled={isLoader}>
                        {isLoader ? <Loader /> : 'Login'}
                    </button>
                  </div>
                  
                  <div className="text-center mt-3">
                    {!isCustomer &&
                      <button 
                        type="button" 
                        className="btn btn-link" 
                        onClick={() => setIsCustomer(!isCustomer)}
                      >
                        {isCustomer ? 'Login as Staff/Admin' : 'Login as Customer'}
                      </button>
                    }
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
